import PropTypes from 'prop-types';

const IssueSuggestion = {
  key: PropTypes.string,
  summary: PropTypes.string,
};

export default IssueSuggestion;
